module.exports = __webpack_public_path__ + "img/users.12adfd19.svg";